import type { GuestUser } from "@/hooks/queries/useMe";

export const MOCK_GUEST_USER: GuestUser = {
    isLoggedIn: false,
};